document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[id^="ComprarJaCustom-"]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var form = btn.closest('form') || document.querySelector('form[action*="/cart/add"]');
      if (!form) return;

      var formData = new FormData(form);
      btn.disabled = true;
      btn.textContent = 'Adicionando...';

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Erro ao adicionar ao carrinho');
        return res.json();
      })
      .then(function() {
        window.location.href = '/cart';
      })
      .catch(function(err) {
        console.error(err);
        btn.disabled = false;
        btn.textContent = 'Comprar Já';
        alert('Não foi possível adicionar o produto ao carrinho. Tente novamente.');
      });
    });
  });
});